import FolderTreeType from '../store/schema/FolderTreeType';
import { action } from 'satcheljs';

/**
 * Action called to set the FolderTreeType in store.
 */
export default action('setFolderTreeType', (folderTreeType: FolderTreeType) => ({
    folderTreeType,
}));
